import React from 'react';

export const Slat50mm = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__slat" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__bslat">
        <use xlinkHref="#prefix__slat" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__bslat)"
        fill="#fff"
        stroke="#233762"
        strokeWidth={4.853}
        strokeMiterlimit={10}
      >
        <path d="M53.1 97l-67.5-6.5V64.2l81.5 7.2z" />
        <path d="M53.1 77.3l-67.5-6.5V44.6l81.5 7.2z" />
        <path d="M53.1 57.7l-67.5-6.5V24.9l81.5 7.3z" />
        <path d="M53.1 38.1l-67.5-6.5V5.3l81.5 7.2z" />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
